import _ from 'underscore';

export const getBackgroundChangeODataService = ({
  odata, oDataConfig, aid, cid,
}) => {
  const removeImageBackground = (imageUrl) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.RemoveBackground`;
    const requestBody = {
      Url: imageUrl,
    };
    return odata.post(url, _.extend({ data: requestBody }, oDataConfig));
  };

  const getImageSegmentations = (imageUrl) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.GetImageSegmentation`;
    const requestBody = {
      ImageUrl: imageUrl,
    };
    return odata.post(url, _.extend({ data: requestBody }, oDataConfig));
  };

  const generateImageBackground = ({
    prompt,
    // it could be original image url, in such case, the selectedMasks contains the mask ids user selected
    // if it's the url returned from 'removeImageBackground', the selectedMasks should be null
    imageUrl,
    // array of mask ids, if it's empty [], it means no mask is selected
    // if it's null, it means no masks are applied
    maskSetsBase64,
    selectedMasks,
    outputImageWidth,
    outputImageHeight,
  }) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.GenerateImageBackground`;
    const requestBody = {
      ImageUrl: imageUrl,
      Prompt: prompt,
      MaskSets: maskSetsBase64,
      SelectedMasks: selectedMasks,
      Width: outputImageWidth,
      Height: outputImageHeight,
    };
    return odata.post(url, _.extend({ data: requestBody }, oDataConfig));
  };

  const generateMultipleImageBackgrounds = ({
    prompt,
    imageUrl,
    maskSetsBase64,
    selectedMasks,
    outputImageWidth,
    outputImageHeight,
  }) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.GenerateMultipleImageBackgrounds`;
    const requestBody = {
      ImageUrl: imageUrl,
      Prompt: prompt,
      MaskSets: maskSetsBase64,
      SelectedMasks: selectedMasks,
      Width: outputImageWidth,
      Height: outputImageHeight,
    };
    return odata.post(url, _.extend({ data: requestBody }, oDataConfig));
  };

  const getGenerateMultipleImageBackgroundsTaskStatus = (taskId) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.GetMultipleImageBackgroundsTaskStatus(TaskId='${taskId}')`;
    return odata.get(url, oDataConfig);
  };

  return {
    removeImageBackground,
    getImageSegmentations,
    generateImageBackground,
    generateMultipleImageBackgrounds,
    getGenerateMultipleImageBackgroundsTaskStatus,
  };
};

